import React from "react";
import { Paper, Typography, Button, Box } from "@mui/material";

// Catches render/lifecycle errors of the routed page so a crash blanks only the content pane,
// never the whole layout (React unmounts the entire root on an uncaught render error).
export default class ErrorBoundary extends React.Component {
    state = { error: null };
    static getDerivedStateFromError(error) { return { error }; }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("Page crashed:", error, info?.componentStack);
    }
    render() {
        const { error } = this.state;
        if (!error) return this.props.children;
        return (
            <Paper sx={{ m: 3, p: 3, maxWidth: 800 }}>
                <Typography variant="h6" color="error" gutterBottom>This page crashed</Typography>
                <Typography variant="body2" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap", mb: 2 }}>
                    {String(error?.message || error)}
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button variant="contained" onClick={() => this.setState({ error: null })}>Try again</Button>
                    <Button variant="outlined" onClick={() => window.location.reload()}>Reload</Button>
                </Box>
            </Paper>
        );
    }
}
